<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h3 class="panel-title text-primary">Informações do Carimbo do Tempo do E-mail</h3>
    </div>
    <ul class="list-group">
      <li class="list-group-item">Carimbo (base64): <pre id="carimbo">{{ carimboEmail.carimbo }}</pre></li>
      <li class="list-group-item">Conteúdo: <pre class="carimbo">{{ carimboEmail.conteudo }}</pre></li>
      <li class="list-group-item">Hash: <strong>{{ carimboEmail.hashAssinado }}</strong></li>
      <li class="list-group-item">Serial: <strong>{{ carimboEmail.serial }}</strong></li>
      <li class="list-group-item">Emitido Por: <a href="https://www.documentoeletronico.com.br/" target="_blank"><strong>{{ carimboEmail.emitidoPor }}</strong></a></li>
      <li class="list-group-item">Algoritmo: <strong>{{ carimboEmail.algoritimo }}</strong></li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'AppInfoEmailQualisoftCarimboTempo',

  props: {
    carimboEmail: {
      type: Object
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/provider-qualisoft/InfoEmailQualisoftCarimboTempo.vue